import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Kriszta from './views/Kriszta.vue';
import Pal from './views/Pal.vue';
import eqc from './views/EQC.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/a-tudatos-autohasznalatrol',
      name: 'kriszta',
      component: Kriszta,
    },
    {
      path: '/az-innovacio-iranti-vonzalomrol',
      name: 'pal',
      component: Pal,
    },
    {
      path: '/mercedes-eqc',
      name: 'eqc',
      component: eqc,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } return { x: 0, y: 0 };
  },
});
